// eslint-disable-next-line import/prefer-default-export
export const SET_VIEW_MODE_ACTION = 'viewMode';
